import actionTypes from '../actions/types'

const sections = (state = [], action) => {
  switch (action.type) {
    case actionTypes.ADD_SECTION:
      return state.concat(action.payload)
    case actionTypes.REMOVE_SECTION:
      return state
    case actionTypes.ADD_SECTION_ELEMENT:
      return Object.assign({}, state, action.payload)
    case actionTypes.REMOVE_SECTION_ELEMENT:
      return Object.assign({}, state, action.payload)
    default:
      return state
  }
};

export default sections


// WEBPACK FOOTER //
// ./app/javascript/app/site/reducers/sections.js